import { useT } from "@/i18n";
import { GLOSSARY, WEB_TEXT } from "@/components/webdev/content";

export default function Glossary() {
  const { lang } = useT();
  return (
    <div>
      <h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{WEB_TEXT[lang].glossary}</h3>
      <div className="mt-4 grid sm:grid-cols-3 gap-4">
        {GLOSSARY.map((g) => (
          <div key={g.id} className={`${g.color} rounded-3xl border-4 border-white p-4 shadow-md`} data-testid={`web-glossary-${g.id}`}>
            <p className="font-fredoka text-2xl font-bold text-blue-950">{g[lang][0]}</p>
            <p className="mt-1 text-blue-900 font-semibold text-sm">{g[lang][1]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
